"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalize = exports.InstrumentationBase = void 0;
var node_1 = require("./node");
Object.defineProperty(exports, "InstrumentationBase", { enumerable: true, get: function () { return node_1.InstrumentationBase; } });
Object.defineProperty(exports, "normalize", { enumerable: true, get: function () { return node_1.normalize; } });
//# sourceMappingURL=index.js.map